import {
	POST_ACCESS,
	POST_ACCESS_ERROR,
	POST_ACCESS_SUCCESS,
} from '../../constants';

export const postAccessReducer = (state, actions) => {
	switch (actions.type) {
		case POST_ACCESS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_ACCESS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_ACCESS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				access: actions.payload,
			};
		default:
			return state;
	}
};
